import {Component} from '@angular/core';

@Component({
  selector: 'voice-menu-node',
  templateUrl: './voice-menu-node.component.html'
})
export class VoiceMenuNodeComponent {
    node
}
